import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { InterventionPendingChecklist } from "models";

export const useAddPendingChecklistMutation = () =>
  useTypedMutation({
    mutationFn: (payload: InterventionPendingChecklist) => ApiInstance.post("/interventions/pending_checklists/add", payload, ENV.appointmentBaseURL),
    onSuccess: payload => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.interventions) return;

      const interventionIdx = appointment.interventions.findIndex(intervention => intervention.id === payload.intervention_id);
      if (interventionIdx < 0) return;

      const intervention = appointment.interventions[interventionIdx];
      const pendingChecklistIdx = intervention.pending_checklists?.findIndex(pc => pc.checklist_id === payload.checklist_id) ?? -1;
      if (pendingChecklistIdx >= 0) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        interventions: appointment.interventions.with(interventionIdx, { ...intervention, pending_checklists: [...(intervention.pending_checklists ?? []), payload] })
      });
    }
  });
